export const REVENUE_GLOSSARY = [
  {
    key: 'revenue.opportunityId',
    label: 'Número da oportunidade',
    whatIs: 'Número único do cartão da oportunidade no PI.',
    purpose: 'Identifica o cartão ao combinar com o time ou cruzar a planilha com o histórico de status.',
    howGenerated: 'Gerado pelo PI quando a regra cria o cartão. Um cartão novo depois de outro encerrado ganha outro número e cita o anterior.',
  },
  {
    key: 'revenue.feature',
    label: 'Funcionalidade',
    whatIs: 'Funcionalidade de venda avulsa que a empresa ainda não tem liberada e que uma regra apontou como possível venda adicional.',
    purpose: 'É o produto a ofertar. O nome abre o detalhe da funcionalidade.',
    howGenerated: 'Só entram funcionalidades marcadas como avulsas e vendáveis no catálogo, que a empresa não tem liberadas, nem a equivalente (Documentos e Documentos V2, por exemplo).',
    seeAlso: ['revenue.commercialClass'],
  },
  {
    key: 'revenue.commercialClass',
    label: 'Classe comercial',
    whatIs: 'Como a funcionalidade é vendida segundo o catálogo do PI: venda avulsa, base do produto, incluída no produto, sem gate, parceiro, customização ou técnica.',
    purpose: 'Diz se a funcionalidade pode virar venda adicional: só a venda avulsa gera oportunidade.',
    howGenerated: 'Vem do catálogo de funcionalidades do PI, mantido pelo time; não é lido do contrato da empresa.',
    caveat: 'A classe nasceu como rascunho e precisa da revisão de Revenue antes de servir de base para uma indicação.',
  },
  {
    key: 'revenue.plan',
    label: 'Plano',
    whatIs: 'Periodicidade da assinatura ativa da empresa: mensal, bimestral, trimestral, semestral, anual ou bianual.',
    purpose: 'Situa a conversa comercial: renovação anual e mensal pedem abordagens diferentes.',
    howGenerated: 'Lido da assinatura ativa no retrato noturno mais recente da empresa.',
  },
  {
    key: 'revenue.status',
    label: 'Status',
    whatIs: 'Situação do cartão no trabalho comercial: Nova, Relevante, Já conhecida e Contatada (abertas) ou Irrelevante, Não elegível, Convertida, Perdida e Expirada (encerradas).',
    purpose: 'Organiza o trabalho de Revenue e registra o retorno de cada indicação, o que mede se as regras acertam.',
    howGenerated: 'Toda oportunidade nasce Nova. Quem tem o acesso de Revenue muda o status com um motivo de lista fechada; só o sistema leva a Expirada.',
    caveat: 'Um cartão que muda de status continua na tela até a próxima carga, mesmo que saia do filtro escolhido.',
    seeAlso: ['revenue.reason'],
  },
  {
    key: 'revenue.reason',
    label: 'Motivo do status',
    whatIs: 'Motivo escolhido, de uma lista fechada, na última mudança de status: fit confirmado, sem necessidade, preço, concorrente e outros.',
    purpose: 'Explica por que a indicação avançou ou parou, para ajustar as regras e a abordagem.',
    howGenerated: 'Gravado com a mudança de status no histórico do cartão. Os motivos do sistema são: não detectada de novo em 30 dias, substituída por oportunidade mais forte e empresa marcada como demonstração.',
    seeAlso: ['revenue.status'],
  },
  {
    key: 'revenue.statusBy',
    label: 'Status alterado por',
    whatIs: 'Quem fez a última mudança de status do cartão: o nome do usuário do Master ou "Sistema".',
    purpose: 'Diz com quem falar sobre o andamento da oportunidade.',
    howGenerated: 'Vem do login de quem mudou o status, nunca de um campo digitado. Expiração e substituição aparecem como "Sistema"; cartão que nunca mudou fica vazio.',
    seeAlso: ['revenue.statusAt'],
  },
  {
    key: 'revenue.statusAt',
    label: 'Status alterado em',
    whatIs: 'Data e hora, no horário de Brasília, da última mudança de status do cartão.',
    purpose: 'Mostra há quanto tempo o cartão está parado no status atual.',
    howGenerated: 'Gravada com a mudança no histórico do cartão. Cartão que nunca mudou de status fica com o campo vazio.',
    seeAlso: ['revenue.statusBy'],
  },
  {
    key: 'revenue.strength',
    label: 'Força do sinal',
    whatIs: 'Quão forte é a evidência mais forte do cartão: forte, moderada ou fraca.',
    purpose: 'Ordena o trabalho: pedido explícito e teste em uso vêm antes de semelhança com empresas do mesmo porte.',
    howGenerated: 'Cada regra define a força: pedido de contato e teste em uso são fortes, cliques na tela bloqueada e espelho sem assinatura são moderados, pares do mesmo porte são fracos.',
    seeAlso: ['revenue.evidence'],
  },
  {
    key: 'revenue.noResponse',
    label: 'Sem retorno',
    whatIs: 'Selo do cartão Contatada há mais de 45 dias sem nenhuma atualização de status.',
    purpose: 'Lembra de cobrar o retorno do cliente ou de encerrar a oportunidade como perdida.',
    howGenerated: 'Calculado na leitura: status Contatada com a última mudança há mais de 45 dias. O status não muda sozinho.',
  },
  {
    key: 'revenue.commercialState',
    label: 'Estado comercial',
    whatIs: 'Situação da funcionalidade na empresa: em teste, contratada, padrão, liberada sem evidência comercial, equivalente liberada, sem gate ou não liberada.',
    purpose: 'Separa o que já foi vendido do que só está liberado, antes de ofertar ou de cobrar.',
    howGenerated: 'Deduzido da liberação no retrato noturno e das evidências de venda (preço na assinatura ou liberação na venda inicial), sem item de contrato por funcionalidade.',
    caveat: 'É uma dedução: liberada sem evidência pode ser cortesia, teste esquecido ou venda registrada fora do sistema.',
    seeAlso: ['revenue.verifiedOn'],
  },
  {
    key: 'revenue.verifiedOn',
    label: 'Estado comercial conferido em',
    whatIs: 'Dia do retrato noturno em que o estado comercial foi conferido.',
    purpose: 'Mostra quão recente é a informação de liberação e venda.',
    howGenerated: 'Data do retrato que trouxe a origem da liberação; sem ela, a do retrato mais recente da empresa.',
    seeAlso: ['revenue.commercialState'],
  },
  {
    key: 'revenue.detectedOn',
    label: 'Detecção',
    whatIs: 'Dia em que uma regra detectou a oportunidade pela primeira vez.',
    purpose: 'Mostra há quanto tempo o sinal existe; sinal antigo sem contato é oportunidade esfriando.',
    howGenerated: 'Gravado pelo processamento das oportunidades, que roda toda madrugada às 02:17 (Brasília) com as regras ligadas.',
    seeAlso: ['revenue.expiresOn'],
  },
  {
    key: 'revenue.expiresOn',
    label: 'Expira em',
    whatIs: 'Dia em que o cartão aberto (Nova, Relevante ou Já conhecida) expira se nenhuma regra o detectar de novo.',
    purpose: 'Avisa que o sinal está perdendo validade.',
    howGenerated: 'Última detecção mais 30 dias. Cada nova detecção adia a data. Cartão Contatada ou encerrado não expira.',
    seeAlso: ['revenue.detectedOn'],
  },
  {
    key: 'revenue.why',
    label: 'Observação',
    whatIs: 'Frase que explica o sinal da regra, como "A empresa pediu contato sobre a funcionalidade ou tentou abrir a tela bloqueada".',
    purpose: 'Dá o contexto em uma linha antes de ler a evidência.',
    howGenerated: 'Texto fixo de cada regra (O1 a O4), escolhido pela regra da evidência mais forte do cartão.',
    seeAlso: ['revenue.evidence'],
  },
  {
    key: 'revenue.evidence',
    label: 'Evidência',
    whatIs: 'Os fatos que cada regra encontrou: sinais com valor (pedidos, cliques, usos, pares), o período lido, desde quando há medição e quando foi detectada.',
    purpose: 'Permite conferir a indicação com dados antes de falar com o cliente.',
    howGenerated: 'Gravada por regra a cada detecção. Regras diferentes somam evidência no mesmo cartão. Na exportação, as evidências ficam numa célula, separadas por " | ".',
    seeAlso: ['revenue.strength'],
  },
  {
    key: 'revenue.limitations',
    label: 'Limitações',
    whatIs: 'O que a indicação não sabe: estado comercial deduzido, sem valor estimado e sem probabilidade, e desde quando os sinais são medidos.',
    purpose: 'Evita tratar a indicação como certeza.',
    howGenerated: 'Lista do PI para o cartão, mais o aviso fixo sobre o estado comercial e a data de início da medição dos sinais.',
  },
  {
    key: 'revenue.nextStep',
    label: 'Próximo passo sugerido',
    whatIs: 'Ação recomendada para a regra que gerou o cartão, como "Retornar o contato e entender o que a empresa procura".',
    purpose: 'Orienta o primeiro contato comercial.',
    howGenerated: 'Texto fixo de cada regra (O1 a O4), escolhido pela regra da evidência mais forte do cartão.',
  },
  {
    key: 'revenue.filter.status',
    label: 'Status',
    whatIs: 'Quais cartões a lista mostra: Abertas (padrão: Nova, Relevante, Já conhecida e Contatada), Sem retorno, um status específico ou Todas.',
    purpose: 'Separar o trabalho pendente do histórico de oportunidades encerradas.',
    howGenerated: 'Filtro aplicado no servidor sobre o status gravado. Sem retorno = Contatada há mais de 45 dias sem atualização.',
    seeAlso: ['revenue.status'],
  },
  {
    key: 'revenue.filter.rule',
    label: 'Regra',
    whatIs: 'Mostra só os cartões com evidência da regra escolhida: O1 pedido explícito, O2 teste em uso, O3a complemento do espelho ou O4 pares do mesmo porte.',
    purpose: 'Avaliar uma regra de cada vez: quantas indicações gera e quantas viram venda.',
    howGenerated: 'O cartão entra quando tem pelo menos uma evidência da regra, mesmo que outra regra seja a mais forte.',
  },
  {
    key: 'revenue.filter.feature',
    label: 'Funcionalidade',
    whatIs: 'Mostra só os cartões de uma funcionalidade do catálogo, inclusive os da equivalente (Documentos e Documentos V2, por exemplo).',
    purpose: 'Planejar uma campanha de venda de uma funcionalidade.',
    howGenerated: 'Compara o número da funcionalidade do cartão com o escolhido e com as equivalentes do catálogo do PI.',
  },
  {
    key: 'revenue.filter.size',
    label: 'Porte',
    whatIs: 'Mostra só os cartões de empresas de um porte: A (100 ou mais funcionários), B (50 a 99), C (21 a 49), D (11 a 20) ou E (até 10).',
    purpose: 'Dividir o trabalho comercial pelo tamanho da conta.',
    howGenerated: 'Usa o porte do retrato noturno mais recente de cada empresa, calculado pelo total de funcionários do cadastro.',
  },
  {
    key: 'revenue.filter.company',
    label: 'Empresa',
    whatIs: 'Mostra só os cartões de uma empresa. Chega preenchido pelo link "Abrir a oportunidade" do portfólio da empresa.',
    purpose: 'Ver todas as indicações de uma conta antes de falar com ela.',
    howGenerated: 'Compara o identificador da empresa do cartão; o nome aparece no filtro só para leitura.',
  },
  {
    key: 'revenue.rule',
    label: 'Regras',
    whatIs: 'As regras que geram oportunidades, cada uma com estado, versão, última execução e número de cartões abertos.',
    purpose: 'Diz se uma lista vazia é falta de sinal ou regra desligada, sem dados ou sem execução recente.',
    howGenerated: 'Lidas da configuração das regras do PI. O processamento roda toda madrugada às 02:17 (Brasília); os limiares mudam sem nova versão do sistema.',
  },
  {
    key: 'revenue.rule.enabled',
    label: 'Ligada ou desligada',
    whatIs: 'Se a regra roda no processamento noturno das oportunidades.',
    purpose: 'Regra desligada não gera cartões novos nem atualiza a evidência dos que já existem.',
    howGenerated: 'Chave de cada regra na configuração do PI. A O3b (facial para quem bate por tablet) está desligada de propósito por envolver dado biométrico.',
  },
  {
    key: 'revenue.rule.waiting',
    label: 'Aguardando dados',
    whatIs: 'A regra está ligada, mas ainda não tem histórico medido suficiente para gerar oportunidades; quando há data prevista, ela aparece no selo.',
    purpose: 'Evita ler a falta de cartões como falta de oportunidade.',
    howGenerated: 'O PI compara o início da medição dos sinais que a regra usa com a janela que ela precisa. Até completar a janela, a regra não gera nada.',
  },
  {
    key: 'revenue.rule.partial',
    label: 'Cobertura parcial',
    whatIs: 'A regra roda, mas parte dos sinais dela ainda não é medida em todo o período que ela lê.',
    purpose: 'Avisa que pode haver oportunidades que a regra ainda não enxerga.',
    howGenerated: 'Calculado pelo PI a partir das datas de início da medição de cada sinal; o motivo aparece no cartão da regra.',
  },
  {
    key: 'revenue.portfolio.module',
    label: 'Módulo',
    whatIs: 'Área do produto da funcionalidade no catálogo do PI. No portfólio, cada módulo é uma tabela.',
    purpose: 'Agrupa o que a empresa tem por área do produto.',
    howGenerated: 'Vem do catálogo de funcionalidades do PI, o mesmo usado pelo filtro de módulo.',
  },
  {
    key: 'revenue.portfolio.feature',
    label: 'Funcionalidade',
    whatIs: 'Cada funcionalidade de produto ativa do catálogo do PI, com a classe comercial abaixo do nome.',
    purpose: 'Mostra o portfólio completo da empresa, liberado ou não, numa lista só.',
    howGenerated: 'Catálogo de funcionalidades do PI cruzado com as liberações e as vendas da empresa no retrato noturno.',
    seeAlso: ['revenue.commercialClass'],
  },
  {
    key: 'revenue.portfolio.sellable',
    label: 'Venda',
    whatIs: 'Se a funcionalidade pode ser vendida à parte (Vendável) ou não (Não vendável), segundo o catálogo.',
    purpose: 'Separa o que pode virar venda adicional do que vem no pacote.',
    howGenerated: 'Campo do catálogo de funcionalidades do PI, mantido pelo time.',
  },
  {
    key: 'revenue.portfolio.measured',
    label: 'Medição',
    whatIs: 'Se o PI mede o uso da funcionalidade e desde quando: medida, medida só em parte dos 30 dias, medição começou depois da janela ou sem medição.',
    purpose: 'Diz se dá para confiar na coluna de uso: sem medição não quer dizer sem uso.',
    howGenerated: 'Data do primeiro evento medido da funcionalidade (para a batida, o início da coleta do banco da empresa) comparada com a janela dos últimos 30 dias fechados.',
  },
  {
    key: 'revenue.portfolio.usage',
    label: 'Uso',
    whatIs: 'Quantos usuários elegíveis da empresa usaram a funcionalidade nos últimos 30 dias fechados, de quantos elegíveis ela tem.',
    purpose: 'Mostra se o que foi vendido está em uso: contratada sem uso é risco de cancelamento.',
    howGenerated: 'Usuários habilitados com papel aplicável e pelo menos uma ação bem-sucedida na janela. Fica vazio sem medição na janela e em funcionalidade não liberada sem uso.',
    caveat: 'A janela é sempre de 30 dias fechados e não segue o filtro de período da página.',
    seeAlso: ['revenue.portfolio.usageDetail'],
  },
  {
    key: 'revenue.portfolio.usageDetail',
    label: 'Detalhe do uso',
    whatIs: 'Dias com uso na janela e o dia do último uso; quando a medição cobre só parte da janela, desde quando.',
    purpose: 'Separa uso contínuo de uso pontual.',
    howGenerated: 'Contado nos mesmos eventos da coluna de uso: dias distintos com ação bem-sucedida e o maior dia, nos últimos 30 dias fechados.',
    seeAlso: ['revenue.portfolio.usage'],
  },
  {
    key: 'revenue.portfolio.opportunity',
    label: 'Oportunidade',
    whatIs: 'Link para a oportunidade aberta da empresa para a funcionalidade ou para a equivalente, quando existe.',
    purpose: 'Leva direto ao cartão para registrar o trabalho comercial.',
    howGenerated: 'Procura a oportunidade mais recente com status aberto (Nova, Relevante, Já conhecida ou Contatada) da empresa para a funcionalidade.',
    seeAlso: ['revenue.status'],
  },
];



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/glossary/revenue.js